import {useCallback, useEffect, useState} from "react";
import {InputField, DateRangeField, SelectField} from "../../../../components";
import {userApi} from "~/api";
import {apiError, handleRequest} from "~/utils";
import dayjs from 'dayjs';

function OrderSearchBar({filter, onFilterChange})
{
    const [users, setUsers] = useState([]);
    const [usersLoading, setUsersLoading] = useState(false);

    const handleSearchChange = useCallback((e) => {
        onFilterChange?.({keyword: e.target.value});
    }, [onFilterChange]);

    const handleUserChange = useCallback((value) => {
        onFilterChange?.({user_created: value});
    }, [onFilterChange]);

    const handleDateRangeChange = useCallback((dates) => {
        if (dates && dates.length === 2) {
            onFilterChange?.({
                date_from: dayjs(dates[0]).format('YYYY-MM-DD 00:00:00'),
                date_to: dayjs(dates[1]).format('YYYY-MM-DD 23:59:59')
            });
        } else {
            onFilterChange?.({
                date_from: null,
                date_to: null
            });
        }
    }, [onFilterChange]);

    // Load users list
    useEffect(() => {
        const loadUsers = async () => {
            setUsersLoading(true);
            let [error, response] = await handleRequest(userApi.gets({limit: 100}));
            setUsersLoading(false);

            if (!apiError('Lấy danh sách người dùng thất bại', error, response)) {
                const userOptions = response?.data?.map(user => ({
                    value: user.id,
                    label: user.fullname || user.username
                })) || [];
                setUsers([{value: '', label: 'Tất cả người bán'}, ...userOptions]);
            }
        };

        loadUsers();
    }, []);

    // Convert date strings to dayjs objects for DateRangeField
    const dateRangeValue = (filter?.date_from && filter?.date_to)
        ? [dayjs(filter.date_from), dayjs(filter.date_to)]
        : null;

    return (
        <div className="search-bar pt-0 pb-2">
            <div className="container">
                <form className="form p-0" autoComplete="off">
                    <InputField
                        name="keyword"
                        value={filter?.keyword}
                        placeholder="Mã đơn hàng, tên/SĐT khách hàng"
                        onChange={handleSearchChange}
                    />
                    <SelectField
                        name="user_created"
                        value={filter?.user_created || ''}
                        options={users}
                        placeholder="Chọn người bán"
                        onChange={handleUserChange}
                        loading={usersLoading}
                    />
                    <DateRangeField
                        name="date_range"
                        value={dateRangeValue}
                        placeholder={['Từ ngày', 'Đến ngày']}
                        format="DD-MM-YYYY"
                        onChange={handleDateRangeChange}
                    />
                </form>
            </div>
        </div>
    );
}

export default OrderSearchBar;
